import React, { ReactElement } from 'react'
import { PageSeo } from '@/components/NextSeo/PageSeo'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import { GetStaticProps } from 'next'
import { StudyMaterialsGuidePage } from '@/components/static/StudyMaterialsGuidePage/StudyMaterialsGuidePage'
import { BasePageProps } from '@/globals/pages.types'
import { CourseConfigType } from 'common/src/courseConfig'

// TODO: Should gather the necessary data to populate this page via some kind of config
export const getStaticProps = (async (_context) => {
    return { props: { courseConfigType: CourseConfigType.fsaHealth } }
}) satisfies GetStaticProps<BasePageProps>

const Page = (props: BasePageProps): ReactElement => {
    return (
        <>
            <PageSeo
                title={'How to study for the FSA Group & Health exams'}
                description={
                    'The Just Enough Prep study materials guide: how to use outlines, notecards and practice questions together, how autograding works, and how Eupheus your AI study partner fits into a study plan.'
                }
                canonicalPath={UiLayoutConstant.STUDY_MATERIALS_GUIDE_PAGE}
            />
            <StudyMaterialsGuidePage {...props} isLoggedIn={false} />
        </>
    )
}

Page.isStatic = true

export default Page
